export default __webpack_public_path__ + "static/media/img-clients_4.51e7e99f.png";